import { createBrowserRouter } from "react-router-dom";
import Login from "./pages/login";
import MainLayout from "./layout/main.layout";
import NotFound from "./pages/not-found";

import { isAuthenticated } from "./loaders/authentication";
import { PathnameUrl } from "./constants";
import DeviceManagement from "./pages/device-management";
import LinkManagement from "./pages/link-management";
import StatisticalManagement from "./pages/statistical-management";
import CompanyManagement from "./pages/company-management";
import ChangePasswordPage from "./pages/change-password";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    loader: isAuthenticated,
    children: [
      {
        path: "",
        element: <DeviceManagement />,
      },
      {
        path: PathnameUrl.DEVICE_MANAGEMENT,
        element: <DeviceManagement />,
      },
      {
        path: PathnameUrl.LINK_MANAGEMENT,
        element: <LinkManagement />,
      },
      {
        path: PathnameUrl.COMPANY_MANAGEMENT,
        element: <CompanyManagement />,
      },
      {
        path: PathnameUrl.STATISTICAL_MANAGEMENT,
        element: <StatisticalManagement />,
      },
      {
        path: PathnameUrl.CHANGE_PASSWORD,
        element: <ChangePasswordPage />,
      },
      {
        path: PathnameUrl.CALL_MANAGEMENT,
        element: <h1>call</h1>,
      },
      {
        path: PathnameUrl.ANSWER_MANAGEMENT,
        element: <h1>answer</h1>,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
    loader: isAuthenticated,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
